import { Container } from '@mui/material'
import LoginContainer from '~/src/components/auth/login/LoginContainer'
import useGetLoginTemplate from '~/src/pages/auth/login/styles/useGetLoginTemplate'
import DocumentTitleInjector from '~/src/components/root/DocumentTitleInjector'
import ContentContainer from '~/src/components/utils/layout/ContentContainer'
import RoutesEnum from '~/src/router/enums/routes.enum'
import SlideFromRight from '~/src/components/mui-wrappers/animations/motion/SlideFromRight'

const Login = () => {
  const pageName: keyof typeof RoutesEnum = 'LOGIN'
  const styles = useGetLoginTemplate()

  return (
    <SlideFromRight
      pathname={pageName}
      transition={{
        duration: .5
      }}
    >
      <DocumentTitleInjector pageName={pageName} />
      <Container sx={styles.getPageSx()}>
        <ContentContainer>
          <LoginContainer />
        </ContentContainer>
      </Container>
    </SlideFromRight>
  )
}

export default Login
